"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _Border = _interopRequireDefault(require("./components/Border"));

var _amsAssignToProject = _interopRequireDefault(require("../wrappers/ams-assign-to-project"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = (0, _amsAssignToProject["default"])(function (_ref) {
  var groups = _ref.groups,
      user = _ref.user,
      group = _ref.group,
      authLevel = _ref.authLevel,
      update = _ref.update,
      canSubmit = _ref.canSubmit,
      handleSubmit = _ref.handleSubmit;
  return /*#__PURE__*/_react["default"].createElement(_Border["default"], {
    className: "max-w-2xl pb-4"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-b-2 mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-4 gap-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2 font-bold"
  }, "Assign to Project"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-1"
  }, "Authority Level"))), /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: handleSubmit
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-4 gap-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Select, {
    domain: groups,
    accessor: function accessor(g) {
      return g.name;
    },
    multi: false,
    value: group,
    onChange: function onChange(group) {
      return update({
        group: group
      });
    },
    placeholder: "Select a group..."
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-1"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Input, {
    type: "number",
    min: "0",
    max: user.authLevel,
    required: true,
    value: authLevel,
    onChange: function onChange(v) {
      return update({
        authLevel: v
      });
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-1 flex justify-center"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    type: "submit",
    block: true,
    disabled: !canSubmit
  }, "assign")))));
});

exports["default"] = _default;